<script setup>
import { ref } from 'vue';
import DsModal from 'JIX/components/ds/DsModal.vue';
import { __ } from 'JIX/gettext.js';
import { updateUser } from 'JIX/user/api.js';
import PromiseButton from 'JIX/components/PromiseButton.vue';
import { useStore } from 'vuex';
import getToastManager from 'JIX/ui/toasts.js';

const travelTimeModal = ref();
const addressLine = ref();
const addressZipcode = ref();
const addressCity = ref();

const store = useStore();

function show() {
    travelTimeModal.value.show();
}

defineExpose({
    show,
});

async function save() {
    const updatedUser = {
        address_line: addressLine.value,
        address_zipcode: addressZipcode.value,
        address_city: addressCity.value,
    };
    await updateUser(updatedUser).then(() => {
        travelTimeModal.value.hide();
        return store.dispatch('performSearch');
    }).catch(() => {
        getToastManager().createToast({
            title: __("Fejl"),
            message: __("Kunne ikke gemme adresse"),
            type: 'danger'
        }).show();
    });
}

</script>

<template>
    <DsModal
        ref="travelTimeModal"
        role="dialog"
        :show="false"
        :title="__('Din adresse')"
        size="lg"
    >
        <form
            id="traveltimeForm"
            class="d-flex flex-column gap-3"
            @submit.prevent="save"
        >
            <div class="form-group required mb-0 w-100">
                <label class="control-label" for="address_line">{{ __('Adresse') }}</label>
                <input
                    type="text"
                    class="form-control"
                    name="address_line"
                    id="address_line"
                    autocomplete="street-address"
                    v-model="addressLine"
                    required
                >
            </div>
            <div class="d-flex gap-2">
                <div class="form-group required mb-0">
                    <label class="control-label" for="address_zipcode">{{ __('Postnummer') }}</label>
                    <input
                        type="text"
                        class="form-control"
                        name="address_zipcode"
                        id="address_zipcode"
                        autocomplete="postal-code"
                        v-model="addressZipcode"
                        required
                    >
                </div>
                <div class="form-group required mb-0 w-100 traveltime-input-city">
                    <label class="control-label" for="address_city">{{ __('By') }}</label>
                    <input
                        type="text"
                        class="form-control"
                        name="address_city"
                        id="address_city"
                        autocomplete="address-level2"
                        v-model="addressCity"
                        required
                    >
                </div>
            </div>
        </form>
        <template #footer>
            <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="travelTimeModal.hide"
            >
                {{ __("Annuller") }}
            </button>
            <PromiseButton
                type="submit"
                class="btn btn-primary"
                form="traveltimeForm"
            >
                {{ __("Gem adresse") }}
                <template #inprogress>
                    {{ __("Gemmer") }}
                </template>
            </PromiseButton>
        </template>
    </DsModal>
</template>
